import styled from 'styled-components';

const GroupTitle = styled.h3`
  font-size: 1.35em;
  font-weight: 700;
  line-height: 1.875;
  margin: 0 0 1.25rem;
  text-align: left;
`;

const GroupWrapper = styled.div`

`;

export default {
  GroupTitle,
  GroupWrapper,
};
